var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();